// Generated by ReScript, PLEASE EDIT WITH CARE


var dummyResponse = {
    "logout_success": true,
  };

export {
  dummyResponse ,
}
/* No side effect */
